<template>
  <vue-link :to="`/shop/p/${product.handle}`" class="product-grid-item nord">
    <figure v-if="coverImage">
      <img :src="coverImage.url" :alt="coverImage.altText" />
    </figure>

    <h2 class="uppercase">{{ product.title }}</h2>

    <div v-if="product.availableForSale">
      <span v-if="firstAvailableVariant.compareAtPriceV2" class="compare-at-price">
        {{ compareAtPrice }}
      </span>
      <span :class="firstAvailableVariant.compareAtPriceV2 ? 'has-compare-at-price' : ''">
        {{ price }}
      </span>
    </div>
    <div v-else>
      Sold Out
    </div>
  </vue-link>
</template>

<script>
import { formatMoney } from '@/lib/shopify-utils'

export default {
  name: 'ProductItem',
  props: {
    product: Object,
  },
  computed: {
    coverImage() {
      return this.product.featuredImage
    },
    firstAvailableVariant() {
      return this.product.selectedOrFirstAvailableVariant
    },
    price() {
      return formatMoney(this.firstAvailableVariant.priceV2.amount)
    },
    compareAtPrice() {
      return this.firstAvailableVariant.compareAtPriceV2.amount
    },
  },
}
</script>

<style scoped>
.product-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.product-grid-item {
  border: 1px dashed #fff;
  border-radius: var(--br);
  padding: 3rem;
  text-align: center;
}

.product-grid-item.empty-item {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.product-grid-item figure {
  aspect-ratio: 3/2;
  position: relative;
  margin-bottom: 2rem;
  width: 100%;
}

.product-grid-item figure > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
